const gql = String.raw;
  
export const Space = gql`
query SpaceBySlugQuery($slug: ID!) {
  spaceBySlug(slug: $slug) {
    id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    
        
        
              openGraph { 
                id title 
                description { plain text }
                image { 
                  id url url2x 
                  thumbnails { 
                    id bubbleLarge { id url url2x }
        mainBanner { id url url2x }
        halfBanner { id url url2x }
                  }
                  
                } 
              }
            
        
          entityType { useAi }
          entityViews {
            id name hash label slug count showCount
            type { id name slug }
            slices {
              id name slug label updated
              title 
              titleRich { id text }
              layout { id name slug component }
              themeMode { id name slug }
              openGraph {
                id
                image { url thumbnails { large { url } bubble { url url2x } } }
              }
              emptyTout { id text }
              ownEmptyTout { id text }
              entityFormFields {
                name
                label
                description
                ownDescription
                type
                formFieldType
                entityTypeName
                entityTypeNamePlural
                entityTypeDefinition {
                  name
                  label
                  pluralName
                  pluralLabel
                  createAnotherLabel
                  createLabel
                  formFields {
                    label
                    description
                    ownDescription
                    name
                    type
                    formFieldType
                    required
                    entityTypeName
                    entityTypeNamePlural
                  }
                }
              }
              headerFontType { internalName }
              bodyFontType { internalName }
              disabled
              connectedEntities { name label internalName }
              entityLayout { internalName }
              created updated
              outro { id text }
              intro { id text }
              content { 
                id plain text 
                linkEmbeds { 
                    id name _label url slug __typename
                    image { id url width height }
                  } 
                linkRichEmbeds { 
                  id name _label url slug __typename
                  image { id url width height }
                }
              }
              backgroundColor { id value }
              color { id value }
              icon { id slug name component }
              embeds {
                citations {
                  slug url name authors { id name slug } 
                  authorShowsEtAl edition publication accessDate 
                  startPage volume footnoteNumber year
                }
                posts {
                  id name slug path
                  openGraph {
                    title description { plain(truncate: {words: 20}) }
                    image { url url2x type }
                  }
                }
                imageAssets {
                  id
                  slug
                  image {
                    id url url2x width height type 
                  }
                }
              }
              people {
                id name slug path __typename
                organisation { id name }
                linkedin
                position
                openGraph { id image { thumbnails { bubble { url url2x } card { url url2x } } } }
              }
              spaceMemberships {
                id name slug path __typename _schema { label  pluralLabel } 
                person {
                  id name slug path __typename
                  
                        openGraph { 
                          id title 
                          
                          image { 
                            id url url2x 
                            thumbnails { 
                              id bubbleMedium { id url url2x }
                            }
                            
                          } 
                        }
                      
                }
                role {
                  id name slug path __typename
                  
                        openGraph { 
                          id title 
                          
                          image { 
                            id url url2x 
                            thumbnails { 
                              id bubbleMedium { id url url2x }
                            }
                            
                          } 
                        }
                      
                }
              }
              trends {
                
                  id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
                
                outlineNumber
                color { __typename id slug name value }
                openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
              }
              topics {
                
                  id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
                
                outlineNumber
                color { __typename id slug name value }
                openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
              }
              subTopics {
                
                  id name slug typeLabel badge updated __typename _schema { label pluralLabel }
                
                outlineNumber
                color { __typename id slug name value }
                openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
              }
              events {
                
                  
                
                    id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
                
                  
                  
                        openGraph { 
                          id title 
                          
                          image { 
                            id url url2x 
                            thumbnails { 
                              id bubbleMedium { id url url2x }
                            }
                            
                          } 
                        }
                      
                
              }
            }
          }
        
        type { id name slug }
        statuses { id name slug }
        agenda { id text }
        followersCount
        moderators {
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
           
          position
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
          organisation { id name slug }
        }
        events { 
           
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel } 
          
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        trends {
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          outlineNumber
          color { __typename id slug name value }
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        topics {
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          outlineNumber
          color { __typename id slug name value }
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        subTopics {
          
            id name slug typeLabel badge updated __typename _schema { label pluralLabel }
          
          outlineNumber
          color { __typename id slug name value }
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        members {
          id name slug path __typename _schema { label pluralLabel }
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        organisationMembers {
          id name slug path __typename _schema { label pluralLabel }
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        followers {
          id name slug path
          openGraph { id image { id url url2x } }
        }
        comments {
          id
          embeds {
            imageAssets { id slug image { id url url2x width height } }
          }
        }
        activities {
          id name path slug due __typename _schema { label pluralLabel }
          tasks { id path slug completed due name _label description { text } }
          status { id name slug }
          files { id name slug }
          people {
            id path slug name
            role { id name slug }
            organisation { id slug name }
            openGraph { id image { id url url2x }
          }
          teamRoles { 
            id slug path 
            role { id name }
          }
        }
      }
    
    banner {
      id name slug title description { text } alternateText
      image { 
        id url url2x width height thumbnails { halfBanner { url url2x } } 
      }
    }
  }
}
`;
